import React from 'react'

const PermissionDenied = (props) => {

    return(
        <div className="d-flex flex-column justify-content-center align-items-center mt-4">
            <h3>Permission Denied</h3>
            <p>You don't have access to this page.</p>
        </div>
    )

}

export default PermissionDenied